import { render, staticRenderFns } from "./AamsLicenseRegInfo.vue?vue&type=template&id=42e51cb2&scoped=true&"
import script from "./AamsLicenseRegInfo.vue?vue&type=script&lang=js&"
export * from "./AamsLicenseRegInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e51cb2",
  null
  
)

export default component.exports